import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ChargeFailPage } from '@/features/coins/components/charge-fail-page';

/** 토스 failUrl 쿼리 — code·message 와(결제창까지 간 경우) orderId */
const searchSchema = z.object({
  code: z.string().max(100).catch('UNKNOWN').default('UNKNOWN'),
  message: z.string().optional().catch(undefined),
  orderId: z
    .string()
    .regex(/^[A-Za-z0-9_-]{6,64}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/_auth/charge/fail')({
  validateSearch: searchSchema,
  staticData: { title: '결제 결과' },
  head: () => ({ meta: [{ title: '결제 결과 · 팬즈드롭 코인 충전' }] }),
  component: ChargeFailRoute,
});

function ChargeFailRoute() {
  const { code, message, orderId } = Route.useSearch();
  return <ChargeFailPage code={code} message={message} orderId={orderId} />;
}
